import "babel-polyfill";
import "./libs/jcf";
import "./libs/jcf.select";
import "./libs/jcf.scrollable";
import "./libs/jquery-ui";

import { binder, fwa } from "./libs/binder";
import { constants } from "./modules/module";
import { customSelect } from "./modules/custom-select";
import { mobileNavigation } from "./modules/mobile-navigation";
import { moveBg } from "./modules/move-bg";
import { moveBgX } from "./modules/move-bg-x";
import { swipeSlider } from "./modules/swipe-slider";
import { arrowSlider } from "./modules/arrow-slider";
import { accordion } from "./modules/accordion";
import { checkSymptoms } from "./modules/check-symptoms";
import { scrollAnimate} from "./modules/scroll-animate";
import { anchors } from "./modules/anchors";
import { quizSteps } from "./modules/quiz-steps";
import { popups } from "./modules/popups";
import { datePicker } from "./modules/date-picker";
import { validateNumbers } from "./modules/validate-numbers";
import { otherInput } from "./modules/other-input";


binder({
    bounds: {
        "html": [constants],
        ".main-nav": mobileNavigation,
        "select": [customSelect, otherInput],
        ".move-bg": moveBg,
        ".move-bg-x": moveBgX,
        ".swipe-slider": swipeSlider,
        ".arrow-slider": arrowSlider,
        ".accordion": accordion,
        ".symptoms-list": checkSymptoms,
        ".scrolled": scrollAnimate,
        ".anchor-link": anchors,
        ".steps-wrap": quizSteps,
        ".popups": popups,
        ".date-picker": datePicker,
        ".input-number": validateNumbers,

    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js